import { SERVER_URL } from '../../../constants';
import {
  fetchGetAuth,
  fetchPostAuth,
  fetchRemoveAuth
} from '../../../util/FetchUtil';

const controller = 'evento-aluno/';

const findByEvento = (codEvento) => {
  const url = SERVER_URL + controller + 'evento/' + codEvento;
  return fetchGetAuth(url);
}

const save = (eventoAluno) => {
  const url = SERVER_URL + controller;
  return fetchPostAuth(url, eventoAluno);
}

const remove = (codEventoAluno) => {
  const url = SERVER_URL + controller + codEventoAluno;
  return fetchRemoveAuth(url);
}

export {
  findByEvento,
  save,
  remove,
}